import '../styles/footer.css'
import { FaFacebook, FaInstagram, FaGoogle } from 'react-icons/fa';

function Footer() {
    
    return(<>
    
    <footer>
      <div>
        <h2>Redes</h2>
          <a 
          href="https://www.facebook.com/share/1NKduCSiVf/?mibextid=wwXIfr&rdid=gfsA9oRN2iIq9ZjF&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14Ez69VCJub%2F#" 
          title='Facebook'
          target="_blank" 
          rel="noopener noreferrer"
          >
            <FaFacebook size={34} style={{margin: 15}}/>
          </a>
          <a href="https://g.co/kgs/Kh5mf2c" target="_blank" rel="noopener noreferrer" title='Google Maps'>
            <FaGoogle size={32} style={{margin: 15}}/>
          </a>
          <a href="https://www.instagram.com/hechicero_leo_dantor?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
          target="_blank" rel="noopener noreferrer" title='Instagram'>
            <FaInstagram size={34} style={{margin: 15}}/>
          </a>
        <h2>Teléfono</h2>
          <ul>
          <li>+1 829-484-1919</li>
          </ul>
          
      </div><br />
      <hr /><br />
    <a href="https://www.freepik.es/foto-gratis/fondo-espacio-exterior_4101021.htm#fromView=search&page=1&position=37&uuid=ee4cd31c-778a-4989-b317-04b90e232efc&query=espacio+mistico" target="_blank" rel="noopener noreferrer" >
        Hero Image by Freepik
    </a><br />
    <a href="https://bsitescomp.com" target="_blank" rel="noopener noreferrer" >
        &copy; Copyright 2025 Web Developed by <strong>B-Sites</strong>
    </a>
  </footer>

    </>);
}

export default Footer;